import { render, staticRenderFns } from "./CreateTaxPph4Verse2.vue?vue&type=template&id=2d56424c"
import script from "./CreateTaxPph4Verse2.vue?vue&type=script&lang=js"
export * from "./CreateTaxPph4Verse2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports